import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/armatuaventura/page.tsx");
